export const applyDataTestId = (testId: string) => {
  return testId
    .replace(/[\[\]'"]/g, "")
    .split("=")
    .pop();
};

export const extractDataTestId = (inputString: string): string | null => {
  const regex = /\[data-testid='([^']+)'\]/;
  const match = inputString.match(regex);

  if (match && match[1]) {
    return match[1];
  } else {
    return null;
  }
};
